import { Col } from "react-bootstrap";
import { Box, Tooltip, Button, Typography } from "@mui/material";

export default function ToolbarBtn(props) {
  const {
    tooltipId,
    tooltipTitle,
    btnId,
    btnClassName,
    btnVariant,
    btnSubVariant,
    btnDisabled,
    onClick,
    icon,
    btnLabel,
    width
  } = props;
  return (
    <Col xs="auto">
      <Box className="bx">
        <Tooltip id={tooltipId} title={tooltipTitle} placement="bottom">
          <Button
            className={btnClassName || ""}
            id={btnId || ""}
            disabled={btnDisabled}
            variant={btnVariant || "toolbar-btn"}
            sub_variant={btnSubVariant || "primary"}
            owner="admin"
            onClick={onClick ?? undefined}
          >
            <Typography variant="subtitle2" owner="admin" className="btn-lh">
              {width <= 1200 ? (icon) : (btnLabel)}
            </Typography>
          </Button>
        </Tooltip>
      </Box>
    </Col>
  );
}
